<template>
  <div>
    <button @click="show" type="button"
            class="btn btn-secondary btn-sm mr-1">
      <font-awesome-icon icon="list"/>&nbsp;{{ $t('user') }}
    </button>
    <b-modal v-model="showDetailModel" size="xl" ok-only :title="$t('users')" content-class="modal-content-2"
             header-bg-variant="white" footer-bg-variant="white">
      <div class="c-smart-table tile"
           style="
              max-height: 500px;
              overflow-y: auto;
           ">
        <div class="row c-smart-table__title">
          <div class="col-lg-2">{{ $t('user') }}</div>
          <div class="col-lg-2">{{ $t('ip') }}</div>
          <div class="col-lg-4">UA</div>
          <div class="col-lg-2">{{ $t('country') }}</div>
          <div class="col-lg-2">{{ $t('createTime') }}</div>
        </div>
        <div class="row" v-for="item in model.users" :key="item._id">
          <div class="col-lg-2">
            <span v-if="item.user">{{ item.user.name }} ({{ item.user.ext }})</span>
            <span v-else class="text-gray small">{{ $t('notUpdated') }}</span>
          </div>
          <div class="col-lg-2">
            <span v-if="item.ip">{{ item.ip }}</span>
            <span v-else class="text-gray small">{{ $t('notUpdated') }}</span>
          </div>
          <div class="col-lg-4">
            <span v-if="item.ua">{{ item.ua }}</span>
            <span v-else class="text-gray small">{{ $t('notUpdated') }}</span>
          </div>
          <div class="col-lg-2">
            <span v-if="item.countryCode">{{ getCountryLabel(item.countryCode) }}</span>
            <span v-else class="text-gray small">{{ $t('notUpdated') }}</span>
          </div>
          <div class="col-lg-2">
            <span v-if="item.createTime">{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            <span v-else class="text-gray small">{{ $t('notUpdated') }}</span>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <button class="btn btn-secondary" @click="showDetailModel = false">{{ $t('close') }}</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
const countries = {
  // 🇻🇳 Đông Nam Á
  "VN": {name: "Vietnam", flag: "🇻🇳"},
  "TH": {name: "Thailand", flag: "🇹🇭"},
  "KH": {name: "Cambodia", flag: "🇰🇭"},
  "LA": {name: "Laos", flag: "🇱🇦"},
  "MM": {name: "Myanmar", flag: "🇲🇲"},
  "MY": {name: "Malaysia", flag: "🇲🇾"},
  "SG": {name: "Singapore", flag: "🇸🇬"},
  "ID": {name: "Indonesia", flag: "🇮🇩"},
  "PH": {name: "Philippines", flag: "🇵🇭"},
  "BN": {name: "Brunei", flag: "🇧🇳"},
  "TL": {name: "Timor-Leste", flag: "🇹🇱"},

  // 🇦🇸 Châu Á khác
  "CN": {name: "China", flag: "🇨🇳"},
  "JP": {name: "Japan", flag: "🇯🇵"},
  "KR": {name: "South Korea", flag: "🇰🇷"},
  "IN": {name: "India", flag: "🇮🇳"},
  "PK": {name: "Pakistan", flag: "🇵🇰"},

  // 🇪🇺 Châu Âu
  "FR": {name: "France", flag: "🇫🇷"},
  "DE": {name: "Germany", flag: "🇩🇪"},
  "GB": {name: "United Kingdom", flag: "🇬🇧"},
  "IT": {name: "Italy", flag: "🇮🇹"},
  "ES": {name: "Spain", flag: "🇪🇸"},
  "NL": {name: "Netherlands", flag: "🇳🇱"},
  "BE": {name: "Belgium", flag: "🇧🇪"},
  "RU": {name: "Russia", flag: "🇷🇺"},
  "HU": {name: "Hungary", flag: "🇭🇺"},
  "GR": {name: "Greece", flag: "🇬🇷"},

  // 🌎 Châu Mỹ
  "US": {name: "United States", flag: "🇺🇸"},
  "CA": {name: "Canada", flag: "🇨🇦"},
  "BR": {name: "Brazil", flag: "🇧🇷"},
  "CO": {name: "Colombia", flag: "🇨🇴"},

  // 🌍 Khác
  "AU": {name: "Australia", flag: "🇦🇺"},
  "EG": {name: "Egypt", flag: "🇪🇬"},
  "ZA": {name: "South Africa", flag: "🇿🇦"},
  "IR": {name: "Iran", flag: "🇮🇷"},
};

export default {
  props: ['model'],
  data() {
    return {
      service: '/fault-detection-ip',
      showDetailModel: false,
      data: []
    }
  },
  methods: {
    show() {
      this.showDetailModel = true;
    },
    getCountryLabel(code) {
      return countries[code] ? countries[code].flag + ' ' + countries[code].name : code
    },
  },
  i18n: {
    messages: {
      en: {
        users: "Users list",
        close: "Close",
      },
      vi: {
        users: "Danh sách người dùng",
        close: "Đóng",
      }
    }
  }
}
</script>

<style>
.modal-content-2 {
  background-color: #e5e5e5;
}
</style>